import ui from "./images/ui.svg";
import ecommerce from "./images/ecommerce.svg";
import api from "./images/api.svg";
import seo from "./images/seo.svg";
import globe from "./images/globe.svg";
import fullStack from "./images/fullStack.svg";

const cardData = [
  {
    title: "Web Development",
    desc: "Building fast, responsive, and modern websites tailored to your needs.",
    icon: globe,
  },
  {
    title: "UI/UX Design",
    desc: "Creating visually appealing and user-friendly designs.",
    icon: ui,
  },
  {
    title: "Full-Stack Development",
    desc: "Providing complete web solutions with front-end and back-end expertise.",
    icon: fullStack,
  },
  {
    title: "E-commerce Solutions",
    desc: "Building secure and scalable online stores to help grow your business.",
    icon: ecommerce,
  },
  {
    title: "API Integration",
    desc: "Seamlessly connecting your services and data for optimal performance.",
    icon: api,
  },
  {
    title: "SEO Optimization",
    desc: "Helping your website rank higher on search engines with effective SEO strategies.",
    icon: seo,
  },
];

export default cardData
